var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8B98AB",
    fillRule: "evenodd",
    d: "M0 1.25 1.29 0 8 6.5 1.29 13 0 11.75 5.417 6.5z"
  })));
};
export default SvgChevronRight;